/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
let hexcase = 0;
function hex_md5(a) {
  return rstr2hex(rstr_md5(str2rstr_utf8(a)));
}
function hex_hmac_md5(a, b) {
  return rstr2hex(rstr_hmac_md5(str2rstr_utf8(a), str2rstr_utf8(b)));
}
function md5_vm_test() {
  return hex_md5("abc").toLowerCase() == "900150983cd24fb0d6963f7d28e17f72";
}
function rstr_md5(a) {
  return binl2rstr(binl_md5(rstr2binl(a), a.length * 8));
}
function rstr_hmac_md5(c, f) {
  let e = rstr2binl(c);
  if (e.length > 16) {
    e = binl_md5(e, c.length * 8);
  }
  let a = Array(16),
    d = Array(16);
  for (let b = 0; b < 16; b++) {
    a[b] = e[b] ^ 909522486;
    d[b] = e[b] ^ 1549556828;
  }
  let g = binl_md5(a.concat(rstr2binl(f)), 512 + f.length * 8);
  return binl2rstr(binl_md5(d.concat(g), 512 + 128));
}
function rstr2hex(c) {
  try {
    hexcase;
  } catch (g) {
    hexcase = 0;
  }
  let f = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  let b = "";
  let a;
  for (let d = 0; d < c.length; d++) {
    a = c.charCodeAt(d);
    b += f.charAt((a >>> 4) & 15) + f.charAt(a & 15);
  }
  return b;
}
function str2rstr_utf8(c) {
  let b = "";
  let d = -1;
  let a, e;
  while (++d < c.length) {
    a = c.charCodeAt(d);
    e = d + 1 < c.length ? c.charCodeAt(d + 1) : 0;
    if (55296 <= a && a <= 56319 && 56320 <= e && e <= 57343) {
      a = 65536 + ((a & 1023) << 10) + (e & 1023);
      d++;
    }
    if (a <= 127) {
      b += String.fromCharCode(a);
    } else {
      if (a <= 2047) {
        b += String.fromCharCode(192 | ((a >>> 6) & 31), 128 | (a & 63));
      } else {
        if (a <= 65535) {
          b += String.fromCharCode(
            224 | ((a >>> 12) & 15),
            128 | ((a >>> 6) & 63),
            128 | (a & 63)
          );
        } else {
          if (a <= 2097151) {
            b += String.fromCharCode(
              240 | ((a >>> 18) & 7),
              128 | ((a >>> 12) & 63),
              128 | ((a >>> 6) & 63),
              128 | (a & 63)
            );
          }
        }
      }
    }
  }
  return b;
}
function rstr2binl(b) {
  let a = Array(b.length >> 2);
  for (let c = 0; c < a.length; c++) {
    a[c] = 0;
  }
  for (let c = 0; c < b.length * 8; c += 8) {
    a[c >> 5] |= (b.charCodeAt(c / 8) & 255) << c % 32;
  }
  return a;
}
function binl2rstr(b) {
  let a = "";
  for (let c = 0; c < b.length * 32; c += 8) {
    a += String.fromCharCode((b[c >> 5] >>> c % 32) & 255);
  }
  return a;
}
function binl_md5(p, k) {
  p[k >> 5] |= 128 << k % 32;
  p[(((k + 64) >>> 9) << 4) + 14] = k;
  let o = 1732584193;
  let n = -271733879;
  let m = -1732584194;
  let l = 271733878;
  for (let g = 0; g < p.length; g += 16) {
    let j = o;
    let h = n;
    let f = m;
    let e = l;
    o = md5_ff(o, n, m, l, p[g + 0], 7, -680876936);
    l = md5_ff(l, o, n, m, p[g + 1], 12, -389564586);
    m = md5_ff(m, l, o, n, p[g + 2], 17, 606105819);
    n = md5_ff(n, m, l, o, p[g + 3], 22, -1044525330);
    o = md5_ff(o, n, m, l, p[g + 4], 7, -176418897);
    l = md5_ff(l, o, n, m, p[g + 5], 12, 1200080426);
    m = md5_ff(m, l, o, n, p[g + 6], 17, -1473231341);
    n = md5_ff(n, m, l, o, p[g + 7], 22, -45705983);
    o = md5_ff(o, n, m, l, p[g + 8], 7, 1770035416);
    l = md5_ff(l, o, n, m, p[g + 9], 12, -1958414417);
    m = md5_ff(m, l, o, n, p[g + 10], 17, -42063);
    n = md5_ff(n, m, l, o, p[g + 11], 22, -1990404162);
    o = md5_ff(o, n, m, l, p[g + 12], 7, 1804603682);
    l = md5_ff(l, o, n, m, p[g + 13], 12, -40341101);
    m = md5_ff(m, l, o, n, p[g + 14], 17, -1502002290);
    n = md5_ff(n, m, l, o, p[g + 15], 22, 1236535329);
    o = md5_gg(o, n, m, l, p[g + 1], 5, -165796510);
    l = md5_gg(l, o, n, m, p[g + 6], 9, -1069501632);
    m = md5_gg(m, l, o, n, p[g + 11], 14, 643717713);
    n = md5_gg(n, m, l, o, p[g + 0], 20, -373897302);
    o = md5_gg(o, n, m, l, p[g + 5], 5, -701558691);
    l = md5_gg(l, o, n, m, p[g + 10], 9, 38016083);
    m = md5_gg(m, l, o, n, p[g + 15], 14, -660478335);
    n = md5_gg(n, m, l, o, p[g + 4], 20, -405537848);
    o = md5_gg(o, n, m, l, p[g + 9], 5, 568446438);
    l = md5_gg(l, o, n, m, p[g + 14], 9, -1019803690);
    m = md5_gg(m, l, o, n, p[g + 3], 14, -187363961);
    n = md5_gg(n, m, l, o, p[g + 8], 20, 1163531501);
    o = md5_gg(o, n, m, l, p[g + 13], 5, -1444681467);
    l = md5_gg(l, o, n, m, p[g + 2], 9, -51403784);
    m = md5_gg(m, l, o, n, p[g + 7], 14, 1735328473);
    n = md5_gg(n, m, l, o, p[g + 12], 20, -1926607734);
    o = md5_hh(o, n, m, l, p[g + 5], 4, -378558);
    l = md5_hh(l, o, n, m, p[g + 8], 11, -2022574463);
    m = md5_hh(m, l, o, n, p[g + 11], 16, 1839030562);
    n = md5_hh(n, m, l, o, p[g + 14], 23, -35309556);
    o = md5_hh(o, n, m, l, p[g + 1], 4, -1530992060);
    l = md5_hh(l, o, n, m, p[g + 4], 11, 1272893353);
    m = md5_hh(m, l, o, n, p[g + 7], 16, -155497632);
    n = md5_hh(n, m, l, o, p[g + 10], 23, -1094730640);
    o = md5_hh(o, n, m, l, p[g + 13], 4, 681279174);
    l = md5_hh(l, o, n, m, p[g + 0], 11, -358537222);
    m = md5_hh(m, l, o, n, p[g + 3], 16, -722521979);
    n = md5_hh(n, m, l, o, p[g + 6], 23, 76029189);
    o = md5_hh(o, n, m, l, p[g + 9], 4, -640364487);
    l = md5_hh(l, o, n, m, p[g + 12], 11, -421815835);
    m = md5_hh(m, l, o, n, p[g + 15], 16, 530742520);
    n = md5_hh(n, m, l, o, p[g + 2], 23, -995338651);
    o = md5_ii(o, n, m, l, p[g + 0], 6, -198630844);
    l = md5_ii(l, o, n, m, p[g + 7], 10, 1126891415);
    m = md5_ii(m, l, o, n, p[g + 14], 15, -1416354905);
    n = md5_ii(n, m, l, o, p[g + 5], 21, -57434055);
    o = md5_ii(o, n, m, l, p[g + 12], 6, 1700485571);
    l = md5_ii(l, o, n, m, p[g + 3], 10, -1894986606);
    m = md5_ii(m, l, o, n, p[g + 10], 15, -1051523);
    n = md5_ii(n, m, l, o, p[g + 1], 21, -2054922799);
    o = md5_ii(o, n, m, l, p[g + 8], 6, 1873313359);
    l = md5_ii(l, o, n, m, p[g + 15], 10, -30611744);
    m = md5_ii(m, l, o, n, p[g + 6], 15, -1560198380);
    n = md5_ii(n, m, l, o, p[g + 13], 21, 1309151649);
    o = md5_ii(o, n, m, l, p[g + 4], 6, -145523070);
    l = md5_ii(l, o, n, m, p[g + 11], 10, -1120210379);
    m = md5_ii(m, l, o, n, p[g + 2], 15, 718787259);
    n = md5_ii(n, m, l, o, p[g + 9], 21, -343485551);
    o = safe_add(o, j);
    n = safe_add(n, h);
    m = safe_add(m, f);
    l = safe_add(l, e);
  }
  return Array(o, n, m, l);
}
function md5_cmn(h, e, d, c, g, f) {
  return safe_add(bit_rol(safe_add(safe_add(e, h), safe_add(c, f)), g), d);
}
function md5_ff(g, f, k, j, e, i, h) {
  return md5_cmn((f & k) | (~f & j), g, f, e, i, h);
}
function md5_gg(g, f, k, j, e, i, h) {
  return md5_cmn((f & j) | (k & ~j), g, f, e, i, h);
}
function md5_hh(g, f, k, j, e, i, h) {
  return md5_cmn(f ^ k ^ j, g, f, e, i, h);
}
function md5_ii(g, f, k, j, e, i, h) {
  return md5_cmn(k ^ (f | ~j), g, f, e, i, h);
}
function safe_add(a, d) {
  let c = (a & 65535) + (d & 65535);
  let b = (a >> 16) + (d >> 16) + (c >> 16);
  return (b << 16) | (c & 65535);
}
function bit_rol(a, b) {
  return (a << b) | (a >>> (32 - b));
}
function urlParams(name) {
  let results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
    window.location.search
  );

  return results !== null ? results[1] || 0 : false;
}

let product = urlParams("p") as string;
let configuration = urlParams("c") as string;
let user = urlParams("b") as string;
let bubbleBackground = urlParams("bg");
let foreground = urlParams("fg");
let baseUrl = "https://s3.eu-central-1.amazonaws.com/cloud-myarstudio-public/";
let iosModelUrl = `${user}/Playground/Products/${product}/default/${configuration}/export/usdz/export.usdz`;
let modelUrl = `${user}/Playground/Products/${product}/default/${configuration}/export/glb/export.glb`;
let configUrl = `${user}/Playground/Products/${product}/default/${configuration}/configuration.xml`;
let posterUrl = `${user}/Playground/Products/${product}/default/${configuration}/export/preview.jpg`;
let qrCode = `${baseUrl}${user}/qr/${hex_md5(
  decodeURI(product) + decodeURI(configuration)
)}.png`;
let environment = "";
let backgroundColor = "#ffffff";
let model = document.createElement("model-viewer");
let productUrl = "";
let scalingEnabled = true;
let envIntensity = 1;
(<any>model).style.setProperty("--ar-button-display", 'none');

fetch(baseUrl + configUrl)
  .then((response) => response.text())
  .then((str) => new window.DOMParser().parseFromString(str, "text/xml"))
  .then((d) => {
    let conf = d.getElementsByTagName("Configuration")[0];
    if(conf != null) {
        scalingEnabled = conf.getAttribute("disableScaling") == "true";
        productUrl = conf.getAttribute("productUrl");
    } else {
        scalingEnabled = true;
        productUrl = "";
    }

    let environmentTag = d.getElementsByTagName("Environment")[0];
    environment = `${environmentTag.getElementsByTagName("Image")[0].textContent}`;
    envIntensity = parseFloat(environmentTag.getElementsByTagName("Image")[0].getAttribute("intensity"));
    (<any>model).exposure = envIntensity;
    let bkgNode = environmentTag.getElementsByTagName("Background")[0];
    if (bkgNode.attributes["sameAsEnvironment"].textContent != "true") {
      (<any>model).environmentImage = environment;
    } else {
      (<any>model).skyboxImage = environment;
    }

    let color = bkgNode.attributes["color"].textContent;
    if(color == null){
      color = "#ffffff"
    }

    if (color.length > 7 && color.indexOf("#ff") > -1) color = color.replace("#ff", "#");
    backgroundColor = color;

    (<any>model).style.backgroundColor = backgroundColor;

    (<any>model).poster = baseUrl + posterUrl;

    (<any>model).style.setProperty("--poster-color", backgroundColor);
    (<any>model).style.setProperty("--progress-bar-height", "15px");
    if (bubbleBackground != false) {
      (<any>model).style.setProperty("--progress-bar-color", "#" + bubbleBackground);
    } else {
      bubbleBackground = "fff";
      (<any>model).style.setProperty("--progress-bar-color", "#808080");
    }

    if (foreground == false) {
      foreground = "161616";
    }

    let animationNode = d.getElementsByTagName("Animation")[0];
    let playAnimation = "";
    if(animationNode != null)
    {
      playAnimation = animationNode.getAttribute("name");
    }

    let hotspotNodes = d.getElementsByTagName("Hotspots")[0];
    if(hotspotNodes != null){
      for(let i = 0; i < hotspotNodes.childElementCount; i ++){
        console.log(hotspotNodes.children[i]);
        let configAnnotation = hotspotNodes.children[i].getAttribute("label");
        let configNormal = hotspotNodes.children[i].getAttribute("normal");
        let configPosition = hotspotNodes.children[i].getAttribute("position");
        const hotspotElement = document.createElement('button');
        hotspotElement.classList.add('Hotspot');
        hotspotElement.slot = `hotspot-${i}`;
        hotspotElement.dataset['position'] = configPosition;
        if (configNormal) {
          hotspotElement.dataset['normal'] = configNormal;
        }
        hotspotElement.dataset['visibilityAttribute'] = 'visible';
  
        if (configAnnotation) {
          const annotationElement = document.createElement('div');
          annotationElement.classList.add('HotspotAnnotation');
          annotationElement.textContent = configAnnotation;
          hotspotElement.appendChild(annotationElement);
        }
        (<any>model).appendChild(hotspotElement);
      }
    }
    

    (<any>model).autoplay = true;
    (<any>model).animationName = playAnimation;

    document.body.appendChild(model);


    //overlay
    let overlay = document.createElement("div");
    overlay.innerHTML = "";
    overlay.style.position = "absolute";
    overlay.style.left = "0";
    overlay.style.bottom = "0";
    overlay.style.top = "0";
    overlay.style.right = "0";
    overlay.style.display = "none";
    overlay.style.zIndex = "500";
    document.body.appendChild(overlay);

    //popup
    let popup = document.createElement("div");
    popup.innerHTML =
      '<p style="margin:0;margin-top:10px;margin-right:10px;line-height:20px;font-size:14px;text-align:right;color:#' +
      foreground +
      '">Try this product in</p><h1 style="margin:0;margin-right:10px;line-height:20px;font-size:17px;text-align:right;color:#' +
      foreground +
      '">Augmented Reality</h1><img style="margin-top:15px" width="100%" src="' +
      qrCode +
      '" /><a target="_blank" href="http://myarstudio.cloud" style="margin-top:5px;margin-right:5px;margin-bottom:10px;padding-right:5px;font-size:12px;color:#a6a6a6">by myarstudio.cloud</a>';
    popup.style.position = "absolute";
    popup.style.right = "15px";
    popup.style.bottom = "103px";
    popup.style.padding = "20px";
    popup.style.width = "173px";
    popup.style.borderRadius = "10px";
    popup.style.border = "1px solid #262626";
    popup.style.backgroundColor = "#" + bubbleBackground;
    popup.style.display = "none";
    popup.style.textAlign = "right";
    popup.style.color = "#fff";
    popup.style.zIndex = "501";
    document.body.appendChild(popup);

    let popupLower = document.createElement("div");
    popupLower.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="21.199" height="15.76" viewBox="0 0 21.199 15.76">'+
      '<g id="Group-2" transform="translate(-1028.402 -520.726)">'+
      '  <path id="Combined_Shape" data-name="Combined Shape" d="M1028.812,521.013l10.219,14.6,10.16-14.6" fill="#fefefe" stroke="#262626" stroke-width="1"/>'+
      '</g>'+
    '</svg>';
    popupLower.style.position = "absolute";
    popupLower.style.right = "27px";
    popupLower.style.bottom = "-18.5px";
    popup.appendChild(popupLower);

    let watermarkContainer = document.createElement("div");
    watermarkContainer.style.border = "1px solid #262626";
    watermarkContainer.style.borderRadius = "10px";
    watermarkContainer.style.width = '22px';
    watermarkContainer.style.height = '22px';
    watermarkContainer.style.textAlign = 'center';
    watermarkContainer.style.position = "absolute";
    watermarkContainer.style.bottom = "30px";
    watermarkContainer.style.right = "30px";
    watermarkContainer.style.zIndex = "500";
    watermarkContainer.style.cursor = "pointer";
    watermarkContainer.style.padding = "10px";
    watermarkContainer.style.display = "flex";
    watermarkContainer.style.justifyContent = "center";
    watermarkContainer.style.alignItems = "center";
    watermarkContainer.style.backgroundColor = "#" + bubbleBackground;

    (<any>model).addEventListener('load', () => {
      if((<any>model).canActivateAR == false)
      {
        document.body.appendChild(watermarkContainer);
      } else {
        let arButton = document.createElement("button");
        arButton.setAttribute("slot", "ar-button");
        arButton.style.backgroundColor = "#" + bubbleBackground;
        arButton.style.borderRadius = "5px";
        arButton.style.border = "1px solid #333";
        arButton.style.position = "absolute";
        arButton.style.bottom = "25px";
        arButton.style.right = "30px";
        arButton.style.paddingLeft = "8px";
        arButton.style.paddingTop = "8px";
        arButton.style.paddingBottom = "8px";
        arButton.style.textAlign = "middle";
        arButton.style.display = "flex";
        arButton.style.width = "135px";
        arButton.style.fontSize = "11px";
        arButton.style.alignItems = "center";
        arButton.style.zIndex = "999";
        arButton.style.height = "45px";
        arButton.style.justifyContent = "end";
        arButton.style.overflow = "hidden";
        arButton.className = "slide-in-blurred-right enlarge-box";
        arButton.innerHTML =
          "<div class='slide-out-blurred-right' style='margin-right:35px;position:absolute;left:15px;'><span style='font-size:9px'>View in your space</span></div><div style='height:23px;z-index:10;position:absolute; right:7px;background-color:#fff'><img style='padding-left:5px;height:23px;' src='./assets/Logo.svg' /></div>";

        (<any>model).appendChild(arButton);
        (<any>model).style.setProperty("--ar-button-display", 'block');
      }
    })

    let watermarkImage = document.createElement("img");
    watermarkImage.src = "./assets/Logo.svg";
    watermarkImage.style.height = "20px";
    watermarkContainer.appendChild(watermarkImage);
    

    let credits = (e) => {
      overlay.style.display = "block";
      popup.style.display = "block";
      let handler = () => {
        overlay.style.display = "none";
        popup.style.display = "none";
        overlay.removeEventListener(
          e.type == "touchend" ? "touchend" : "click",
          handler
        );
      };
      overlay.addEventListener(
        e.type == "touchend" ? "touchend" : "click",
        handler
      );
    };
    watermarkImage.addEventListener("click", credits);
    watermarkImage.addEventListener("touchend", credits);

    let iosUrl = baseUrl + iosModelUrl;
    if(productUrl) {
      // here we should use productUrl 
      // iosUrl += "#custom=https://www.google.com&customHeight=large&allowsContentScaling=0" 
      iosUrl += `#callToAction=${encodeURI("Product page")}&checkoutTitle=${encodeURI(product)}&checkoutSubtitle=${encodeURI("Go back to the product page")}&allowsContentScaling=0`;
      (<any>model).addEventListener('quick-look-button-tapped', () => {
        document.location.href = productUrl;
      })
    }
    (<any>model).iosSrc = iosUrl;
  });

(<any>model).ar = true;
(<any>model).arModes = "scene-viewer quick-look";
// (<any>model).webxr = true;
(<any>model).src = baseUrl + modelUrl;
(<any>model).autoRotate = false;
(<any>model).cameraControls = true;
// (<any>model).controls = false;
(<any>model).className = "maximize";
(<any>model).style.height = window.innerHeight + "px";
// (<any>model).interactionPolicy = "always-allow";
(<any>model).interactionPrompt = "auto";
(<any>model).interactionPromptThreshold = "1000";
(<any>model).backgroundImage = environment;
(<any>model).style.zIndex = "100";

window.addEventListener("resize", () => {
    (<any>model).style.height = window.innerHeight + "px";
})

// (<any>model).addEventListener("click", function () {
//   (<any>model).cameraControls = true;
// });
//
// (<any>model).addEventListener("mouseout", function () {
//   (<any>model).cameraControls = false;
// });

// (<any>model).addEventListener("load", function () {
//   // this.focus();
//   // this.click();
// });
